/**
 * Minimal CSV parser for the admin roster import (email,password,groupe columns, plus optional
 * nom,prenom,modele, any order). Handles double-quoted fields (with escaped `""`) so
 * passwords/groups containing commas still parse correctly; this app has no existing CSV
 * dependency so a small hand-rolled parser avoids pulling one in for this small column set.
 */
export interface ParsedCsvRow {
  [header: string]: string;
}

export function parseCsv(text: string): ParsedCsvRow[] {
  const lines = text.split(/\r\n|\r|\n/).filter((line) => line.length > 0);
  if (lines.length === 0) {
    return [];
  }

  const headers = parseCsvLine(lines[0]).map((header) => header.trim().toLowerCase());
  return lines.slice(1).map((line) => {
    const values = parseCsvLine(line);
    const row: ParsedCsvRow = {};
    headers.forEach((header, index) => {
      row[header] = (values[index] ?? '').trim();
    });
    return row;
  });
}

function parseCsvLine(line: string): string[] {
  const values: string[] = [];
  let current = '';
  let insideQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];

    if (insideQuotes) {
      if (char === '"' && line[i + 1] === '"') {
        current += '"';
        i += 1;
      } else if (char === '"') {
        insideQuotes = false;
      } else {
        current += char;
      }
    } else if (char === '"') {
      insideQuotes = true;
    } else if (char === ',') {
      values.push(current);
      current = '';
    } else {
      current += char;
    }
  }
  values.push(current);
  return values;
}
